import './style/quasar.styl';
import 'quasar/dist/quasar.ie.polyfills';
import '@quasar/extras/roboto-font-latin-ext/roboto-font-latin-ext.css';
import '@quasar/extras/material-icons/material-icons.css';
import './style/site.scss';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import { Quasar, Notify, Dialog } from 'quasar';
import vueScrollTo from 'vue-scrollto';
import axios from 'axios';

Vue.config.productionTip = false;
axios.defaults.headers.post['Content-Type'] = 'application/json';

Vue.use(Quasar, {
  plugins: { Notify, Dialog },
});
Vue.use(vueScrollTo);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
